module.exports = __webpack_public_path__ + "images/map-style-4-01f2a1e86250da9cbd94541a4d2ccc95.jpg";